/*eslint-disable*/
import React from "react";
import {
  Box,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

export default function Footer() {
  let textColor = useColorModeValue("gray.400", "white");
  return (
    <Box className="auth-footer">
     
        <Text  fontWeight='500' className="auth-footer-text">
        {" "}
        &copy; {1900 + new Date().getYear()}
          All Rights Reserved. Made with love by
          <Link
            mx='3px'
            color={textColor}
            href='https://www.simmmple.com?ref=horizon-chakra-free'
            target='_blank'
            fontWeight='700'>
            Embrill!
          </Link>
        </Text>

    </Box>
  );
}
